import styles from "./TextBox.module.scss";
import classnames from "classnames/bind";
let cx = classnames.bind(styles);

const TextBox = (props) => {
  const {
    className,
    id,
    name,
    value,
    handleChange,
    type,
    min,
    max,
    minLength,
    maxLength,
    pattern,
    removeDecimal = false,
    onFocus = () => {},
    maxDecimalCharaters = 10,
  } = props;

  const onChange = (event) => {
    let { value: val } = event.target;
    if (type === "number" && removeDecimal) {
      // removes decimal values if enabled in case of number type
      let newValue = val && !isNaN(parseInt(val)) ? parseInt(val, 10) : 0;
      if (
        (!max || (max && newValue <= max)) &&
        (!min || (min && newValue >= min))
      ) {
        handleChange(name, Math.abs(val));
      }
    } else if (type === "number") {
      if (parseFloat(val) < parseFloat(event.target.min)) {
        val = event.target.min;
      }
      if (parseFloat(val) > parseFloat(event.target.max)) {
        val = event.target.max;
      }
      handleChange(
        name,
        Math.abs(parseFloat(val).toFixed(maxDecimalCharaters)),
      );
    } else {
      handleChange(name, val);
    }
  };

  const onKeyDown = (event) => {
    if (
      type === "number" &&
      maxLength &&
      event.keyCode >= 48 &&
      event.keyCode <= 57 &&
      // Checking if number of digits before decimal is more than provided max lengeth
      // if yes, then new input wont be accepted
      // parseInt is used to remove the decimal part
      parseInt(event.target.value || 0).toString().length >= Number(maxLength)
    ) {
      event.preventDefault();
    }
    const notAllowedRegex = new RegExp(/([^0-9\.])/);
    if (
      type === "number" &&
      (event.keyCode < 37 || event.keyCode > 40) &&
      event.keyCode !== 8 &&
      notAllowedRegex.test(event.key)
    ) {
      event.preventDefault();
    }
  };
  return (
    <input
      title=""
      className={cx(styles.InputStyles, className)}
      value={Number(value).toString()} //removes leading 0 from the number input
      id={id}
      onKeyDown={onKeyDown}
      onChange={(event) => {
        onChange(event);
      }}
      name={name}
      onFocus={() => onFocus(true)}
      onBlur={() => onFocus(false)}
      type={type}
      min={min}
      max={max}
      minLength={minLength}
      maxLength={maxLength}
      pattern={pattern}></input>
  );
};

export default TextBox;
